import { useEffect, useMemo, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import SERVICES_DATA from "./data";

const FALLBACK_IMAGES = [
  "/images/menu-icin-cephe-44a1019c.png",
  "/images/b.webp",
  "/images/totemt/t.webp",
  "/images/neden-vip-reklam-806d6601.jpg",
  "/images/57e4bf57c706f5f2f63ebf7595deb574-f02c7d1e.jpg",
];

const SERVICE_PROJECT_GALLERY: Record<string, { img: string; label: string }[]> = {
  "reklam-tabela": [
    { img: "/images/rt/20190319_152813.webp", label: "Kurumsal Tabela Uygulaması" },
    { img: "/images/rt/AD%C4%B0DAS%20AVM%20I%C5%9EIKLI%20TABELA.webp", label: "AVM Işıklı Tabela Çalışması" },
    { img: "/images/rt/IMG20211106192149.webp", label: "Dış Cephe Reklam Tabelası" },
    { img: "/images/rt/IMG20211119134819.webp", label: "Gece Görünürlüğü Yüksek Tabela" },
    { img: "/images/rt/IMG_20201002_182603%20(1).webp", label: "Cephe Yazısı ve Logo Uygulaması" },
    { img: "/images/rt/IMG_20211023_121800.webp", label: "Kurumsal Mağaza Tabela Detayı" },
  ],
  "isikli-tabela": [
    { img: "/images/it/AD%C4%B0DAS%20AVM%20I%C5%9EIKLI%20TABELA.webp", label: "Işıklı Tabela Uygulaması" },
    { img: "/images/it/20190321_015941.webp", label: "Gece Görünürlüğü Yüksek Tabela" },
    { img: "/images/it/IMG_20210302_185833.webp", label: "LED Aydınlatmalı Cephe Yazısı" },
    { img: "/images/it/IMG_20210608_231036.webp", label: "Kurumsal Işıklı Tabela Çalışması" },
    { img: "/images/it/IMG_20210702_202942.webp", label: "Mağaza Önü Işıklı Tabela" },
    { img: "/images/it/20260129_133908920_iOS.webp", label: "Güncel Işıklı Tabela Uygulaması" },
  ],
  "isiksiz-tabela": [
    { img: "/images/iz/20190319_152813.webp", label: "Kurumsal Işıksız Tabela Uygulaması" },
    { img: "/images/iz/IMG_20170816_173144.webp", label: "Dış Cephe Işıksız Yazı Çalışması" },
    { img: "/images/iz/IMG_20181229_141650.webp", label: "Mağaza Önü Işıksız Tabela" },
    { img: "/images/iz/IMG_20210623_170600.webp", label: "Cephe Kimliklendirme Uygulaması" },
    { img: "/images/iz/IMG_20210629_153943.webp", label: "Kurumsal Tabela Görünüm Detayı" },
    { img: "/images/iz/IMG_20210716_164725.webp", label: "Işıksız Tabela Uygulama Detayı" },
    { img: "/images/iz/IMG_20210717_163220.webp", label: "Geniş Cephe Işıksız Tabela" },
    { img: "/images/iz/20240417_095445464_iOS.webp", label: "Güncel Işıksız Tabela Çalışması" },
  ],
  "cephe-kaplama": [
    { img: "/images/d/d-1.webp", label: "Kompozit Cephe Uygulaması" },
    { img: "/images/d/d-5.webp", label: "Kurumsal Dış Cephe Kaplama" },
    { img: "/images/d/d-6.webp", label: "Mağaza Cephe Yenileme" },
    { img: "/images/d/d-10.webp", label: "Modern Cephe Detayı" },
    { img: "/images/d/d%20(11).webp", label: "Cephe Tasarım Varyasyonu" },
  ],
  "kutu-harf-tabela": [
    { img: "/images/kharft/6-1.webp", label: "Paslanmaz Kutu Harf Uygulaması" },
    { img: "/images/kharft/6%20(2).webp", label: "Kutu Harf Üretim ve Montaj" },
    { img: "/images/kharft/b1%20(1).webp", label: "Özel Tasarım Harf Tabela" },
    { img: "/images/kharft/b1%20(2).webp", label: "Cephe Yazısı Uygulaması" },
    { img: "/images/kharft/b1%20(3).webp", label: "Kurumsal Dış Mekan Harf" },
    { img: "/images/kharft/b1%20(5).webp", label: "Mağaza Giriş Tabela Uygulaması" },
    { img: "/images/kharft/b1%20(6).webp", label: "Dış Cephe Marka Yazısı" },
    { img: "/images/kharft/b1%20(7).webp", label: "Gece Görünürlüğü Yüksek Tabela" },
    { img: "/images/kharft/b1%20(8).webp", label: "Kurumsal Cephe Harf Tasarımı" },
    { img: "/images/kharft/b1-7.webp", label: "LED Aydınlatmalı Cephe Yazısı" },
    { img: "/images/kharft/b1-4.webp", label: "Kurumsal Kutu Harf Montajı" },
    { img: "/images/kharft/b.webp", label: "Özel Üretim Kutu Harf Detayı" },
  ],
  "totem-tabela": [
    { img: "/images/totemt/1.webp", label: "LED Aydınlatmalı Giriş Totemi" },
    { img: "/images/totemt/2.webp", label: "Cadde Tipi Totem Tabela" },
    { img: "/images/totemt/3.webp", label: "Kurumsal Yönlendirme Totemi" },
    { img: "/images/totemt/IMG_20201228_190956.webp", label: "Yüksek Totem Gövde Tasarımı" },
    { img: "/images/totemt/IMG_20210320_140610.webp", label: "Yüksek Totem Uygulaması" },
    { img: "/images/totemt/IMG_20211020_192446.webp", label: "Gece Görünür Totem Çalışması" },
  ],
  "cafe-restorant-dekorasyon": [
    { img: "/images/dekorasyon/20240416_075603470_iOS.webp", label: "Cafe İç Mekan Dekorasyonu" },
    { img: "/images/dekorasyon/20240416_075608709_iOS.webp", label: "Konsept Masa ve Oturma Düzeni" },
    { img: "/images/dekorasyon/20240416_075742109_iOS.webp", label: "Dekoratif Tavan ve Aydınlatma" },
    { img: "/images/dekorasyon/IMG_20210814_180257.webp", label: "Restorant Oturma Alanı Tasarımı" },
    { img: "/images/dekorasyon/IMG_20210914_184543.webp", label: "Mekan Kimliği ve Duvar Uygulaması" },
    { img: "/images/dekorasyon/IMG_20211007_175750.webp", label: "Konsept Dekorasyon Detayı" },
  ],
  "isikli-menu-board": [
    { img: "/images/men/20190321_015941.webp", label: "Işıklı Menü Board Uygulaması" },
    { img: "/images/men/20190318_223346.webp", label: "Restoran Menü Sunum Alanı" },
    { img: "/images/men/20190613_001641.webp", label: "Menü Board Cephe Görünümü" },
    { img: "/images/men/7B2B2117-E719-4533-9ED5-3358C95448E3.webp", label: "Mekan İçi Menü Board Detayı" },
  ],
  "anahtar-teslim-proje": [
    { img: "/images/a/a.webp", label: "Anahtar Teslim Proje Uygulaması" },
    { img: "/images/a/a-2.webp", label: "Mağaza Açılış Projesi" },
    { img: "/images/a/a%20(2).webp", label: "Kurumsal Uygulama Detayı" },
  ],
  "led-teknolojisi": [
    { img: "/images/led/l-1.webp", label: "LED Neon Uygulaması" },
    { img: "/images/led/l-2.webp", label: "RGB Piksel LED Sistem" },
    { img: "/images/led/l-3.webp", label: "Dijital LED Board Kurulumu" },
    { img: "/images/led/3.webp", label: "Cephe LED Görünürlük Çalışması" },
    { img: "/images/led/d.webp", label: "LED Aydınlatma Detayı" },
  ],
  "matbaa-baski": [
    { img: "/images/mat/m-1.webp", label: "Kurumsal Branda Baskı" },
    { img: "/images/mat/m-2.webp", label: "Geniş Format Baskı Uygulaması" },
    { img: "/images/mat/m-3.webp", label: "Araç Giydirme Çalışması" },
    { img: "/images/mat/m-4.webp", label: "Folyo ve Sticker Uygulaması" },
    { img: "/images/mat/m%20(2).webp", label: "Yüksek Çözünürlüklü Baskı Detayı" },
  ],
  "grafik-tasarim": [
    { img: "/images/marketing-strategy-planning-strategy-concept.jpg", label: "Marka Strateji Tasarımı" },
    { img: "/images/mat/m-1.webp", label: "Kampanya Görsel Tasarımı" },
    { img: "/images/mat/m-3.webp", label: "Kurumsal Tasarım Uygulama Görseli" },
    { img: "/images/cafe/c%20(2).webp", label: "Menü ve Sunum Tasarımı" },
    { img: "/images/neden-vip-reklam-806d6601.jpg", label: "Kurumsal Kimlik Uygulaması" },
  ],
  "yol-yonlendirme-tabelasi": [
    { img: "/images/y/IMG_20201006_120918.webp", label: "Yol Yönlendirme Tabela Uygulaması" },
    { img: "/images/y/IMG_20201006_121059.webp", label: "Dış Alan Yönlendirme Çözümü" },
    { img: "/images/y/IMG_20201006_121146.webp", label: "Kurumsal Yönlendirme Tabelası" },
    { img: "/images/y/IMG_20201006_155645.webp", label: "Tesis İçi Yönlendirme Levhası" },
    { img: "/images/y/IMG_20201006_155721.webp", label: "Yol Üzeri Yönlendirme Detayı" },
    { img: "/images/y/IMG_3142.webp", label: "Yönlendirme Uygulaması Ek Görsel 1" },
    { img: "/images/y/IMG_3149.webp", label: "Yönlendirme Uygulaması Ek Görsel 2" },
  ],
};

const localOrFallback = (src: string | undefined, idx = 0) => {
  if (src && src.startsWith("/images/")) return src;
  return FALLBACK_IMAGES[idx % FALLBACK_IMAGES.length];
};

type LightboxItem = { src: string; alt: string };

const ServiceDetailPage = () => {
  useScrollAnimation();
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [lightbox, setLightbox] = useState<{ images: LightboxItem[]; index: number } | null>(null);

  const svc = SERVICES_DATA.find((s) => s.slug === slug);
  const lightboxImages = useMemo<LightboxItem[]>(() => {
    if (!svc) return [];
    return [
      { src: localOrFallback(svc.sideImg, 1), alt: `${svc.title} Detay Görseli` },
      ...svc.gallery.map((g, i) => ({ src: localOrFallback(g.img, i + 2), alt: g.label })),
    ];
  }, [svc]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!svc) navigate("/hizmetler", { replace: true });
  }, [slug, svc, navigate]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (!lightbox || lightbox.images.length === 0) return;
      if (e.key === "Escape") setLightbox(null);
      if (e.key === "ArrowRight") {
        setLightbox((prev) => {
          if (!prev) return prev;
          return { ...prev, index: (prev.index + 1) % prev.images.length };
        });
      }
      if (e.key === "ArrowLeft") {
        setLightbox((prev) => {
          if (!prev) return prev;
          return { ...prev, index: (prev.index - 1 + prev.images.length) % prev.images.length };
        });
      }
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightbox]);

  if (!svc) return null;

  const otherServices = SERVICES_DATA.filter((s) => s.slug !== slug).slice(0, 3);
  const projectGallery = SERVICE_PROJECT_GALLERY[svc.slug] ?? [];
  const portfolioItems =
    svc.slug === "grafik-tasarim" && projectGallery.length > 0 ? projectGallery.slice(0, 3) : svc.gallery;
  const portfolioLightboxImages: LightboxItem[] = portfolioItems.map((g, i) => ({
    src: localOrFallback(g.img, i + 2),
    alt: g.label,
  }));
  const projectLightboxImages: LightboxItem[] = projectGallery.map((g, i) => ({
    src: localOrFallback(g.img, i + 6),
    alt: g.label,
  }));

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[70vh] min-h-[480px] flex items-end overflow-hidden bg-[#0D0D0D]">
        <img
          src={localOrFallback(svc.heroImg, 0)}
          alt={svc.title}
          className="absolute inset-0 w-full h-full object-cover object-center"
          style={{ objectPosition: svc.heroPosition ?? "center center" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D0D0D]/90 via-[#0D0D0D]/60 to-[#0D0D0D]/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D]/80 via-transparent to-[#0D0D0D]/30" />
        <div className="absolute top-0 left-0 w-1.5 h-full bg-[#E6A800]" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full pb-16 pt-32">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 mb-6 anim-down d0">
            <Link to="/" className="text-white/40 text-xs font-head hover:text-[#E6A800] tr uppercase tracking-wider">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line text-white/30 text-xs" />
            <Link to="/hizmetler" className="text-white/40 text-xs font-head hover:text-[#E6A800] tr uppercase tracking-wider">Hizmetler</Link>
            <i className="ri-arrow-right-s-line text-white/30 text-xs" />
            <span className="text-[#E6A800] text-xs font-head uppercase tracking-wider">{svc.shortTitle}</span>
          </div>

          <div className="flex items-center gap-3 mb-5 anim-left d1">
            <div className="w-8 h-[2px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">
              VİP Reklam Dekorasyon
            </span>
          </div>
          <h1 className="font-head font-black uppercase text-white text-[clamp(42px,7vw,96px)] leading-[0.88] anim-up d2 max-w-2xl">
            {svc.title}
          </h1>
          <p className="text-white/60 text-sm leading-relaxed max-w-md mt-5 anim-up d3">
            {svc.tagline}
          </p>
          <div className="flex flex-wrap gap-4 mt-8 anim-up d4">
            <a
              href="tel:+905511830918"
              className="inline-flex items-center gap-2.5 px-6 py-3.5 bg-[#E6A800] text-white hover:bg-[#C99500] tr font-head font-700 uppercase tracking-wider text-xs cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-sm" />
              Ücretsiz Teklif Al
            </a>
            <a
              href="https://wa.me/905511830918"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2.5 px-6 py-3.5 border border-white/30 text-white hover:bg-white/10 tr font-head font-700 uppercase tracking-wider text-xs cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-sm" />
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Description */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div className="anim-left">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-8 h-[3px] bg-[#E6A800]" />
                <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Hizmet Detayı</span>
              </div>
              <h2 className="font-head font-black uppercase text-[#0D0D0D] text-4xl md:text-5xl leading-[0.9] mb-6">
                {svc.title}
                <br />
                <span className="text-[#E6A800]">Nedir?</span>
              </h2>
              <p className="text-[#737373] text-sm leading-relaxed mb-5">
                {svc.description}
              </p>
              <p className="text-[#737373] text-sm leading-relaxed mb-8">
                {svc.longDesc}
              </p>
              <p className="text-[#6C6C6C] text-sm leading-relaxed mb-7">
                {svc.metaDesc}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 mb-5">
                <a
                  href="tel:+905511830918"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-[#E6A800] text-white hover:bg-[#C99500] tr font-head font-700 uppercase tracking-wider text-xs cursor-pointer whitespace-nowrap sm:min-w-[180px]"
                >
                  <i className="ri-phone-line" />
                  Hemen Ara
                </a>
                <a
                  href="https://wa.me/905511830918"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-[#25D366] text-white hover:bg-[#1fb85a] tr font-head font-700 uppercase tracking-wider text-sm cursor-pointer whitespace-nowrap sm:min-w-[260px] shadow-[0_10px_24px_rgba(37,211,102,0.28)]"
                >
                  <i className="ri-whatsapp-line text-base" />
                  WhatsApp'tan Teklif Al
                </a>
              </div>
              <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                {[
                  { icon: "ri-medal-line", text: "20+ Yıllık Deneyim" },
                  { icon: "ri-compasses-2-line", text: "Ücretsiz Keşif" },
                  { icon: "ri-tools-line", text: "Tasarım + Üretim + Montaj" },
                ].map((item) => (
                  <div key={item.text} className="inline-flex items-center gap-2 text-[#565656]">
                    <i className={`${item.icon} text-[#C3AE52]`} />
                    <span className="text-xs font-head font-700 uppercase tracking-wide">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="anim-right d2 relative">
              <div className="absolute -inset-3 border-2 border-[#E6A800]/35 pointer-events-none" />
              <div className="absolute -inset-1 border border-[#0D0D0D]/10 pointer-events-none" />
              <div
                className="relative img-zoom overflow-hidden h-[500px] cursor-zoom-in border-[3px] border-[#1A1A1A] shadow-[0_14px_36px_rgba(0,0,0,0.22)]"
                onClick={() => setLightbox({ images: lightboxImages, index: 0 })}
              >
                <img
                  src={localOrFallback(svc.sideImg, 1)}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-3 right-3 w-20 h-[3px] bg-[#E6A800]" />
                <div className="absolute top-3 right-3 w-[3px] h-20 bg-[#E6A800]" />
                <div className="absolute bottom-3 left-3 w-20 h-[3px] bg-[#E6A800]" />
                <div className="absolute bottom-3 left-3 w-[3px] h-20 bg-[#E6A800]" />
              </div>
              <div className="absolute -bottom-6 right-0 bg-[#0D0D0D] px-7 py-5">
                <div className="font-head font-black text-[#E6A800] text-3xl leading-none">20+</div>
                <div className="text-white/60 text-[10px] font-head uppercase tracking-widest mt-1">Yıllık Deneyim</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-24 bg-[#F7F7F7]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-3 mb-5 anim-up">
            <div className="w-8 h-[3px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-sm font-700 uppercase tracking-[0.2em]">Ne Sunuyoruz</span>
          </div>
          <h2 className="font-head font-black uppercase text-[#0D0D0D] text-5xl md:text-6xl leading-[0.9] mb-12 anim-up d1">
            Hizmet <span className="text-[#E6A800]">Kapsamı</span>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {svc.features.map((f, i) => (
              <div
                key={f.title}
                className="bg-white p-6 border border-[#E8E8E8] hover:border-[#E6A800] tr group anim-up cursor-default"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#FFF8DC] group-hover:bg-[#E6A800] tr mb-4">
                  <i className={`${f.icon} text-[#E6A800] group-hover:text-white text-sm tr`} />
                </div>
                <h4 className="font-head font-700 uppercase text-base tracking-wide text-[#0D0D0D] mb-2 group-hover:text-[#E6A800] tr">
                  {f.title}
                </h4>
                <p className="text-[#737373] text-sm leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 bg-[#FCFCFC] border-y border-[#ECECEC]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-3 mb-5 anim-up">
            <div className="w-8 h-[3px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">
              Uygulama Süreci
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { no: "01", title: "Keşif", desc: "Mekan ölçüleri ve ihtiyaç analizi yapılır." },
              { no: "02", title: "Tasarım", desc: "Markanıza uygun görsel ve teknik plan hazırlanır." },
              { no: "03", title: "Üretim", desc: "Onaylanan projeye göre atölye üretimi tamamlanır." },
              { no: "04", title: "Montaj", desc: "Sahada profesyonel kurulum ve teslim yapılır." },
            ].map((step, i) => (
              <div
                key={step.no}
                className="bg-white border border-[#E8E8E8] hover:border-[#E6A800] tr p-5 anim-up"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="font-head font-black text-[#E6A800] text-2xl leading-none mb-2">{step.no}</div>
                <h3 className="font-head font-700 uppercase text-[#0D0D0D] text-sm mb-1">{step.title}</h3>
                <p className="text-[#737373] text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-3 mb-5 anim-up">
            <div className="w-8 h-[3px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Portföy</span>
          </div>
          <h2 className="font-head font-black uppercase text-[#0D0D0D] text-4xl md:text-5xl leading-[0.9] mb-12 anim-up d1">
            Örnek <span className="text-[#E6A800]">Projeler</span>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {portfolioItems.map((g, i) => (
              <div
                key={`${g.img}-${i}`}
                className="relative overflow-hidden group cursor-pointer anim-up h-[260px]"
                style={{ transitionDelay: `${i * 100}ms` }}
                onClick={() => setLightbox({ images: portfolioLightboxImages, index: i })}
              >
                <img
                  src={localOrFallback(g.img, i + 2)}
                  alt={g.label}
                  className="w-full h-full object-cover object-center tr group-hover:scale-105"
                  style={{ objectPosition: g.position ?? "center center" }}
                />
                <div className="absolute inset-0 bg-[#0D0D0D]/50 tr group-hover:bg-[#0D0D0D]/30" />
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <p className="font-head font-700 uppercase text-white text-sm tracking-wide">{g.label}</p>
                </div>
                <div className="absolute bottom-0 left-0 h-[3px] bg-[#E6A800] w-0 group-hover:w-full tr" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {projectGallery.length > 0 && (
        <section className="py-20 bg-[#111111] border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <div className="flex items-center gap-3 mb-5 anim-up">
              <div className="w-8 h-[3px] bg-[#E6A800]" />
              <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">
                Hizmet Galerisi
              </span>
            </div>
            <h2 className="font-head font-black uppercase text-white text-4xl md:text-5xl leading-[0.9] mb-12 anim-up d1">
              {svc.shortTitle} İçin <span className="text-[#E6A800]">Hizmet Galerisi</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {projectGallery.map((g, i) => (
                <div
                  key={`${g.img}-${i}`}
                  className="relative overflow-hidden group cursor-zoom-in anim-up h-[250px] border border-white/15"
                  style={{ transitionDelay: `${i * 80}ms` }}
                  onClick={() => setLightbox({ images: projectLightboxImages, index: i })}
                >
                  <img
                    src={localOrFallback(g.img, i + 6)}
                    alt={g.label}
                    className="w-full h-full object-cover object-center tr group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-[#0D0D0D]/45 tr group-hover:bg-[#0D0D0D]/30" />
                  <div className="absolute bottom-0 left-0 h-[3px] bg-[#E6A800] w-0 group-hover:w-full tr" />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Other Services */}
      <section className="py-20 bg-[#0D0D0D]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center justify-between mb-10 anim-up">
            <div>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-[3px] bg-[#E6A800]" />
                <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Diğer Hizmetler</span>
              </div>
              <h2 className="font-head font-black uppercase text-white text-3xl leading-tight">
                Diğer <span className="text-[#E6A800]">Hizmetlerimiz</span>
              </h2>
            </div>
            <Link
              to="/hizmetler"
              className="hidden md:flex items-center gap-2 font-head font-700 uppercase text-xs tracking-wider text-white/40 hover:text-[#E6A800] tr cursor-pointer whitespace-nowrap group"
            >
              Tümünü Gör
              <i className="ri-arrow-right-line group-hover:translate-x-1 tr" />
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {otherServices.map((s, i) => (
              <Link
                key={s.slug}
                to={`/hizmetler/${s.slug}`}
                className="overflow-hidden bg-white/5 border border-white/10 hover:border-[#E6A800]/60 hover:bg-white/8 tr group cursor-pointer anim-up"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="relative h-28 overflow-hidden">
                  <img
                    src={localOrFallback(s.heroImg, i + 3)}
                    alt={s.title}
                    className="w-full h-full object-cover object-center tr group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-[#0D0D0D]/45 tr group-hover:bg-[#0D0D0D]/30" />
                  <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center bg-[#E6A800]/90 group-hover:bg-[#E6A800] tr">
                    <i className={`${s.icon} text-white text-sm`} />
                  </div>
                </div>
                <div className="p-5">
                  <h4 className="font-head font-700 uppercase text-white text-sm tracking-wide mb-2 group-hover:text-[#E6A800] tr">
                    {s.title}
                  </h4>
                  <p className="text-white/55 text-xs leading-relaxed min-h-[44px]">
                    {s.description.slice(0, 95)}…
                  </p>
                  <div className="mt-3 inline-flex items-center gap-2 text-[#E6A800] font-head font-700 uppercase tracking-wider text-[10px]">
                    Detaya Git
                    <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 tr" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#E6A800]">
        <div className="max-w-4xl mx-auto px-6 text-center anim-scale">
          <h2 className="font-head font-black uppercase text-white text-4xl md:text-5xl leading-[0.9] mb-4">
            Projenizi
          </h2>
          <h2 className="font-head font-black uppercase text-white/30 text-4xl md:text-5xl leading-[0.9] mb-8">
            Hayata Geçirelim
          </h2>
          <p className="text-white/70 text-sm max-w-sm mx-auto mb-10 leading-relaxed">
            Osmaniye ve çevresinde ücretsiz keşif ve teklif için hemen iletişime geçin.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:+905511830918"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-[#E6A800] font-head font-700 uppercase tracking-wider text-sm cursor-pointer whitespace-nowrap hover:bg-gray-50 tr"
            >
              <i className="ri-phone-fill text-sm" />
              +90 551 183 09 18
            </a>
            <a
              href="https://wa.me/905511830918"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-[#25D366]/20 border border-[#25D366]/40 text-white font-head font-700 uppercase tracking-wider text-sm cursor-pointer whitespace-nowrap hover:bg-[#25D366]/35 tr"
            >
              <i className="ri-whatsapp-line text-sm" />
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      <Footer />

      {lightbox && lightbox.images.length > 0 && (
        <div
          className="fixed inset-0 z-[100] bg-black/92 flex items-center justify-center px-4"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center text-white/90 hover:text-white tr"
            onClick={() => setLightbox(null)}
            aria-label="Kapat"
          >
            <i className="ri-close-line text-3xl" />
          </button>

          <button
            className="absolute left-4 md:left-8 w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 text-white tr"
            onClick={(e) => {
              e.stopPropagation();
              setLightbox((prev) => {
                if (!prev) return prev;
                return { ...prev, index: (prev.index - 1 + prev.images.length) % prev.images.length };
              });
            }}
            aria-label="Önceki görsel"
          >
            <i className="ri-arrow-left-s-line text-2xl" />
          </button>

          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={lightbox.images[lightbox.index].src}
              alt={lightbox.images[lightbox.index].alt}
              className="w-full max-h-[82vh] object-contain"
            />
            <div className="mt-4 text-center">
              <p className="text-white text-base font-head uppercase tracking-wide">
                {lightbox.images[lightbox.index].alt}
              </p>
              <p className="text-white/60 text-sm mt-1">
                {lightbox.index + 1} / {lightbox.images.length}
              </p>
            </div>
          </div>

          <button
            className="absolute right-4 md:right-8 w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-white/20 text-white tr"
            onClick={(e) => {
              e.stopPropagation();
              setLightbox((prev) => {
                if (!prev) return prev;
                return { ...prev, index: (prev.index + 1) % prev.images.length };
              });
            }}
            aria-label="Sonraki görsel"
          >
            <i className="ri-arrow-right-s-line text-2xl" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ServiceDetailPage;
